import { AuthRole } from './couch-auth';

export interface GenerateActivationKeyParams {
  role: AuthRole;
  validFrom_utc?: string;
  validUntil_utc?: string;
  multiUseCount?: number /** Number of users that can activate the same key. Used for invite keys only. */;
  /** Test keys function just like normal ones, but such keys are eligible for automatic deletion and user entitlements based on
   * those keys for automatic revocation at regular maintenance intervals. */
  testKey?: boolean;
}

export interface GenerateActivationKeyResults {
  error: string; // empty if all is ok
  code?: string;
}

export interface UseActivationKeyParams {
  code: string;
}

export interface UseActivationKeyResults {
  role?: AuthRole /** role that was activated */;
  licenseExpires_utc?: string /** how long is safe to cache the license */;
  error: string /** empty if all is ok */;
  retry?: boolean /** In case of couch update conflict (multiple users registering the same key) client may want to retry */;
}

export enum UnsubscribeReason {
  HighPrice = 1,
  NoLongerNeed = 2,
  NotSatisfied = 3,
  SwitchToAnother = 4,
  NotPriority = 5,
  Mistake = 6,
  AnotherPlan = 8,  // NB: There is no 7!
  Other = 0,
};

export interface PayProUnsubscribeParams {
  cancellationReasonId: UnsubscribeReason;
  reasonText?: string; // The custom reason for the subscription cancellation request. It is required if cancellationReasonId is not passed.
};

export interface PayProUnsubscribeResult {
  error?: string;
  errorDetails?: any;
  alreadyCanceled?: boolean;
};

export interface PayProResubscribeParams {
  reasonText?: string; // The custom reason for the resubscription request. 
};

export interface PayProResubscribeResult {
  error?: string;
};

export interface DownloadUserDbParams {
  userId?: string;
  email?: string;
  /** CouchDB _id cursor: rows strictly greater than this _id are returned.
   *  Omit on the first call; pass the previous response's nextLastSeenKey
   *  on subsequent calls. */
  lastSeenKey?: string;
  /** Soft cap on docs per page. Server clamps to [1, 1000]; the page may
   *  also be cut short by the server's byte-size budget. */
  limit?: number;
}
export interface DownloadUserDbResult {
  data?: any;
  /** Cursor for the next page (the last `_id` returned in `data`), or null
   *  when this is the last page. Callers stop paginating when this is null. */
  nextLastSeenKey?: string | null;
  error?: string; // empty if all is ok
}